<template>
  <div class="controls-switch">
    <FPRadio 
      :options="options"
      v-model="view"
    ></FPRadio>
  </div>
</template>

<script>
  import Perspective from "@/components/Icons/Perspective.vue";
  import Flat from "@/components/Icons/Flat.vue";
  import Free from "@/components/Icons/Free.vue";
  import FPRadio from "@/components/FPRadio.vue";

  export default {
    name: "ControlsSwitch",
    components: {
      FPRadio
    },
    data() {
      return {
        controls: this.$bluemap.appState.controls,
        options: [
          {
            value: "perspective",
            labelComponent: Perspective
          },
          {
            value: "flat",
            labelComponent: Flat
          },
          {
            value: "free",
            labelComponent: Free
          }
        ]
      }
    },
    computed: {
      isPerspectiveView() {
        return this.controls.state === "perspective";
      },
      isFlatView() {
        return this.controls.state === "flat";
      },
      isFreeFlight() {
        return this.controls.state === "free";
      },
      view: {
        get() {
          return this.controls.state
        },
        set(value) {
          switch (value) {
            case "perspective":
              this.setPerspectiveView()
              break
            case "flat":
              this.setFlatView()
              break
            case "free":
              this.setFreeFlight()
              break
          }
        }
      }
    },
    methods: {
      setPerspectiveView() {
        this.$bluemap.setPerspectiveView(500, this.isFreeFlight ? 100 : 0);
      },
      setFlatView() {
        this.$bluemap.setFlatView(500, this.isFreeFlight ? 100 : 0);
      },
      setFreeFlight() {
        this.$bluemap.setFreeFlight(500);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .controls-switch {
    width: 200px;
  }

  :deep(svg) {
    height: 100%;
  }
</style>